<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Pool } from "@/models/pool.model";
import { getProbeLabel } from "@/shared/utils/probes";

export default defineComponent({
  props: {
    alert: {
      required: true,
      type: Object as PropType<Pool["alerts"][number]>,
    },
  },
  computed: {
    color() {
      if (this.alert.level > 4) {
        return "bg-alert";
      } else if (this.alert.level > 2) {
        return "bg-warning";
      } else {
        return "bg-info";
      }
    },
    probe() {
      if ([1, 7, 8, 10, 36].includes(this.alert.code)) {
        return this.$t(getProbeLabel(this.alert.param)) + " ";
      }
      return "";
    },
    formattedDate() {
      return this.alert.initialDate.toLocaleString([], {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
  },
});
</script>

<template>
  <div>
    <div class="flex items-center gap-2">
      <div :class="`${color} h-[7px] w-[7px] ml-1 rounded-3xl flex-shrink-0`" />

      <div class="font-medium flex-grow flex items-center gap-2">
        {{ probe }}{{ $t(`Alr${alert.code}`) }}
      </div>
      <div class="text-xs flex-shrink-0">{{ formattedDate }}</div>
    </div>
  </div>
</template>
